import {getFormScreen} from './getFormScreen';

export function getFormScreenLifecycle(ctx: any) {
  return getFormScreen(ctx).formScreenLifecycle;
}